import React, { useContext, useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Modal, Tag, Avatar, List, Skeleton, Empty, Switch, Input } from "antd";
import { AuthContext } from "../../../config/AuthContext";
import Login from "../../../newView/Login";
import JutgeColors from "../../../styles/JutgeColors";
import ChatModal from "../components/ChatModal";
import { GetInteraccionsAyuda } from "../../../dao/GetInteraccionsAyuda";
import { GetInteraccionsHistory } from "../../../dao/GetInteraccionsHistory";
import { DeleteQuestion } from "../../../dao/jutge/DeleteQuestion";
import { GetInteraccionsIdTasca } from "../../../dao/GetInteraccionsIdTasca";
import { useParams } from "react-router-dom";
import UseWebSocketSubscription from "../../UseWebSocketSubscription";
import { MessageOutlined, ClockCircleOutlined, UserOutlined, RightOutlined, StarOutlined, StarFilled, LoadingOutlined } from "@ant-design/icons";
import { ToggleInteraccionFavorita } from "../../../dao/ToggleInteraccionFavorita";

interface ChatTableModalProps {
    visible: boolean; // controla si se muestra
    onClose: () => void; // callback al cerrar
    aula?: any; // callback al cerrar
    isProblema?: boolean;
    isTasca?: boolean;
    isHistory?: boolean;
}

const ChatTableModal: React.FC<ChatTableModalProps> = ({ visible, onClose, aula, isProblema = false, isTasca = false, isHistory = false }) => {

    const { isLoggedIn, userId, user } = useContext(AuthContext);

    const { id_aula, id_projecte, id_tasca } = useParams();
    const [selectedRecord, setSelectedRecord] = useState<any | null>(null);
    const [dades, setDades] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [closingId, setClosingId] = useState<string | null>(null);
    const [favoritingId, setFavoritingId] = useState<string | number | null>(null);
    const [showFavoritesOnly, setShowFavoritesOnly] = useState(false);
    const [nameFilter, setNameFilter] = useState("");

    useEffect(() => {
        if (isLoggedIn && visible) {
            console.log(aula);
            checkDades(true);
        }
    }, [isLoggedIn, visible]);

    id_projecte && id_tasca &&
        UseWebSocketSubscription([`/topic/projecte/${id_projecte}/tasca/${id_tasca}`], (topic, msg) => {
            console.log(`Mensaje en ${topic}:`, msg);
            if (msg === true || msg.accion === "REFRESH") {
                checkDades(false);
            }
        });

    async function checkDades(refresh: boolean) {
        if (refresh) setLoading(true);
        let dad;
        if (isHistory) {
            dad = await GetInteraccionsHistory(userId);
        } else if (!isTasca) {
            dad = await GetInteraccionsAyuda(userId, aula?.id || 0);
        } else {
            dad = await GetInteraccionsIdTasca(userId + "", id_aula + "", id_tasca + "");
        }

        const dadesFiltrades = !isProblema ? dad : dad.filter((d: any) => d.id_problema !== 0);

        // Filter based on user role as requested
        let finalDades = dadesFiltrades || [];

        if (!isHistory && (user.tipus === "0" || user.tipus === "1")) {
            // Admin/Teacher: Only pending interactions (estat === 0)
            finalDades = finalDades;//.filter((d: any) => d.estat === 0);
        }
        // Students: All interactions (open and closed) - no filter needed
        // History: Show all

        // History: Show all

        // Sort by unfinished first (estat === 0), then newest first
        finalDades.sort((a: any, b: any) => {
            if (a.estat === 0 && b.estat !== 0) return -1;
            if (a.estat !== 0 && b.estat === 0) return 1;
            return new Date(b.moment).getTime() - new Date(a.moment).getTime();
        });

        setDades(finalDades);
        setLoading(false);
    }

    async function modificaciones() {
        setSelectedRecord(null);
        await checkDades(false);
    }

    async function toggleFavorito(record: any, e: React.MouseEvent) {
        e.stopPropagation();
        setFavoritingId(record.id);
        await ToggleInteraccionFavorita(record.id);
        await checkDades(false);
        setFavoritingId(null);
    }

    function truncate(str: string | null | undefined, max: number) {
        if (!str) return "";
        return str.length > max ? str.substring(0, max) + "..." : str;
    }

    async function tancarChat(record: any, e: React.MouseEvent) {
        e.stopPropagation();
        setClosingId(record.id);
        await DeleteQuestion(record.id_aula, user.tipus === "2" ? userId : record.id_user, -4, record.id + "", (id_projecte || "0") + "", (id_tasca || "0") + "");
        await checkDades(false);
        setClosingId(null);
    }

    if (!isLoggedIn) return <Login />;

    let dadesMostrades = dades;
    if (showFavoritesOnly) {
        dadesMostrades = dadesMostrades.filter((d: any) => d.favorito == 1 || d.favorito === true || d.favorit == 1 || d.favorit === true);
    }
    if (nameFilter.trim()) {
        const term = nameFilter.toLowerCase();
        dadesMostrades = dadesMostrades.filter((d: any) => 
            (d.nom?.toLowerCase() || "").includes(term) || 
            (d.cognoms?.toLowerCase() || "").includes(term)
        );
    }

    return (
        <>
            <Modal
                open={visible}
                onCancel={onClose}
                footer={null}
                width={800}
                centered
                title={
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, paddingBottom: 10, borderBottom: '1px solid #f0f0f0' }}>
                        <span style={{ fontSize: '1.4em', fontWeight: 700, color: '#10a37f' }}>
                            {isHistory ? "Historial de Converses" : "Converses Actives"}
                        </span>
                        <Tag color="blue">
                            {dadesMostrades.filter((d: any) => d.estat === 0).length} Actives
                        </Tag>
                        {isHistory && <Tag color="default">{dadesMostrades.length} Totals</Tag>}
                    </div>
                }
                bodyStyle={{ maxHeight: '70vh', overflowY: 'auto', padding: '20px', backgroundColor: '#fafafa' }}
            >
                {(user.tipus === "0" || user.tipus === "1") && (
                    <div style={{ display: 'flex', gap: 24, marginBottom: 20, alignItems: 'center', backgroundColor: '#fff', padding: '12px 16px', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
                        <Input 
                            placeholder="Cercar per alumne..." 
                            value={nameFilter} 
                            onChange={e => setNameFilter(e.target.value)} 
                            style={{ width: 250 }} 
                            allowClear
                        />
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <span style={{ fontSize: '0.95em', color: '#555', fontWeight: 500 }}>Només Favorits</span>
                            <Switch checked={showFavoritesOnly} onChange={setShowFavoritesOnly} size="small" />
                        </div>
                    </div>
                )}

                {loading && dadesMostrades.length === 0 && dades.length === 0 ? (
                    <Skeleton active avatar paragraph={{ rows: 3 }} />
                ) : dadesMostrades.length === 0 ? (
                    <Empty description={isHistory ? "No hi ha converses a l'historial" : "No hi ha converses actives"} image={Empty.PRESENTED_IMAGE_SIMPLE} />
                ) : (
                    <List
                        itemLayout="horizontal"
                        dataSource={dadesMostrades}
                        split={false}
                        renderItem={(item) => (
                            <List.Item
                                style={{
                                    padding: '0 0 16px 0',
                                    border: 'none'
                                }}
                            >
                                <div
                                    onClick={() => setSelectedRecord(item)}
                                    style={{
                                        backgroundColor: 'white',
                                        borderRadius: '12px',
                                        padding: '16px',
                                        width: '100%',
                                        cursor: 'pointer',
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                                        border: '1px solid #eee',
                                        transition: 'all 0.2s ease',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 16
                                    }}
                                    className="conversation-card"
                                    onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                    onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                >
                                    {/* Avatar Column */}
                                    <div style={{ flexShrink: 0 }}>
                                        <Avatar
                                            size={50}
                                            src={item.avatar || "/default-avatar.png"}
                                            icon={<UserOutlined />}
                                            style={{ border: '2px solid #fff', boxShadow: '0 2px 5px rgba(0,0,0,0.1)' }}
                                        />
                                        {(user.tipus === "0" || user.tipus === "1") && (
                                            <div 
                                                style={{ marginTop: 8, textAlign: 'center', cursor: 'pointer', fontSize: '1.2rem', color: (item.favorito == 1 || item.favorito === true || item.favorit == 1 || item.favorit === true) ? '#faad14' : '#ccc' }}
                                                onClick={(e) => { if (favoritingId !== item.id) toggleFavorito(item, e); }}
                                            >
                                                {favoritingId === item.id ? (
                                                    <LoadingOutlined style={{ color: '#1890ff' }} spin />
                                                ) : (item.favorito == 1 || item.favorito === true || item.favorit == 1 || item.favorit === true) ? (
                                                    <StarFilled />
                                                ) : (
                                                    <StarOutlined />
                                                )}
                                            </div>
                                        )}
                                    </div>

                                    {/* Content Column */}
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                                            <h4 style={{ margin: 0, fontSize: '1rem', fontWeight: 600 }}>
                                                {user.tipus === "2" ? "Anònim" : (item.nom + " " + (item.cognoms || ""))}
                                            </h4>
                                            <span style={{ fontSize: '0.8rem', color: '#999', display: 'flex', alignItems: 'center', gap: 4 }}>
                                                <ClockCircleOutlined /> {new Date(item.moment).toLocaleDateString()}
                                            </span>
                                        </div>

                                        <div style={{ color: '#555', fontSize: '0.9rem', marginBottom: 8, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                                            {item.question ? truncate(item.question, 100) : <i style={{ color: '#aaa' }}>Sin mensaje preview...</i>}
                                        </div>

                                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                            {item.estat === 0 ?
                                                <Tag color="success" style={{ borderRadius: 10 }}>EN CURSO</Tag> :
                                                <Tag color="default" style={{ borderRadius: 10 }}>FINALIZADO</Tag>
                                            }
                                            <Tag icon={<MessageOutlined />} color="geekblue" style={{ borderRadius: 10 }}>
                                                {item.answers?.length || 0} msgs
                                            </Tag>
                                        </div>
                                    </div>

                                    {/* Action Column */}
                                    <div style={{
                                        flexShrink: 0,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: 8,
                                        alignItems: 'flex-end'
                                    }}>
                                        <Button
                                            type="primary"
                                            shape="circle"
                                            icon={<RightOutlined />}
                                            size="large"
                                            style={{ backgroundColor: '#10a37f' }}
                                        />

                                        {item.estat === 0 && user.tipus === "1" && (
                                            <Button
                                                size="small"
                                                danger
                                                type="text"
                                                loading={closingId === item.id}
                                                onClick={(e) => tancarChat(item, e)}
                                                style={{ fontSize: '0.8rem' }}
                                            >
                                                Cerrar chat
                                            </Button>
                                        )}
                                    </div>
                                </div>
                            </List.Item>
                        )}
                    />
                )}
            </Modal>

            {/* Modal con detalle de chat */}
            {selectedRecord && (
                <ChatModal
                    modalVisible={!!selectedRecord}
                    tasca={isTasca}
                    setModalVisible={() => modificaciones()}
                    selectedRecord={selectedRecord}
                />
            )}
        </>
    );
};

export default ChatTableModal;
